import { useQuery } from "@tanstack/react-query";
import { useSession } from "../auth/useSession";
import { fetchJson } from "../lib/api";
import { isDemoMode } from "../lib/env";

export type AssignmentReview = { status: "open" | "assigned" | "unassigned" | "special"; reason: string };
export type AssignmentTask = AssignmentReview & { doc_id: string; doc_type?: string; line_pos: string; description: string | null; doc_number: string | null; doc_date: string | null; supplier: string | null };
export type AssignmentWorklist = { items: AssignmentTask[]; total: number; counts: Record<AssignmentReview["status"],number>; has_more: boolean; offset: number };
export const assignmentStatus = {open:"Artikelzuordnung offen", assigned:"Manuell zugeordnet", unassigned:"Bewusst ohne Zuordnung", special:"Sonderartikel"};
export function useAssignmentWorklist(params: Record<string,string>) {
  const { user } = useSession();
  const allowed = Boolean(user?.active_membership.can_manage_data_quality) && !isDemoMode();
  const query = useQuery({ queryKey:["article-assignment-worklist",user?.customer_id,user?.user_id,params],
    queryFn: async ({signal}) => {
      const result = await fetchJson<AssignmentWorklist>(`/api/article-assignments/worklist?${new URLSearchParams(params)}`,{signal});
      // Position badges must also cover long documents; list pages stay paginated.
      if (params.doc_id && !Object.hasOwn(params, "offset")) {
        while (result.has_more) {
          const next = await fetchJson<AssignmentWorklist>(`/api/article-assignments/worklist?${new URLSearchParams({...params,offset:String(result.items.length)})}`,{signal});
          result.items.push(...next.items); result.has_more = next.has_more;
        }
      }
      return result;
    }, enabled:allowed && (!Object.hasOwn(params, "doc_id") || Boolean(params.doc_id)), retry:false });
  return {...query,allowed};
}

export function assignmentDocumentLabel(type: string | undefined) {
  return ({rechnung:"Rechnung", gutschrift:"Gutschrift", angebot:"Angebot", einzelauftrag:"Auftragsbestätigung", hauptabrufer:"Hauptabruf"} as Record<string,string>)[type ?? ""] ?? "Beleg";
}
export function assignmentDocumentUrl(id: string) {
  const type = id.split(":")[0];
  if (type === "hauptabrufer") return "/coverage";
  return "/belege/" + encodeURIComponent(id);
}
